// extracted by mini-css-extract-plugin
export default {"ExtractionLoadingWrapper":"_ExtractionLoadingWrapper--A2QJn","TextWrapper":"_TextWrapper--VYnYr","AnimatedText":"_AnimatedText--PiXJ2","FadeOut":"_FadeOut--NpSTI"};